import { bool, shape, string } from 'prop-types'
import { kuiperClassNames, Conditional } from '@opallabs/kuiper'
import { isApproval } from '../../../helpers/matchers'

import './styles.scss'

const shouldRenderLabel = (phase) => {
  const isActiveCurrentPhase = phase.is_active && phase.is_current
  const isExpandedCompletePhase = phase.is_complete && phase.isExpanded

  return (
    isApproval(phase.phase_type) &&
    (isActiveCurrentPhase || isExpandedCompletePhase)
  )
}

const labelText = (phase) => {
  if (phase.is_complete) {
    return 'Phase Approved'
  }
  return 'Approvals Sent'
}

const classNames = (phase) => {
  const status = phase.is_complete ? 'approved' : 'sent'
  return kuiperClassNames(
    'approvalStatusLabel',
    `approvalStatusLabel-${status}`
  )
}

const ApprovalStatusLabel = ({ phase }) => (
  <Conditional condition={shouldRenderLabel(phase)}>
    <div className={classNames(phase)}>{labelText(phase)}</div>
  </Conditional>
)

ApprovalStatusLabel.propTypes = {
  phase: shape({
    is_active: bool,
    is_complete: bool,
    is_current: bool,
    isExpanded: bool,
    phase_type: string,
  }).isRequired,
}

export default ApprovalStatusLabel
